import { fraunces } from './fonts';
import { ArrowIcon, CtaButton, Reveal, Stamp } from './ui';

// Boarding-pass closing CTA.
export default function FinalCta({ onJoin }) {
  return (
    <section className="tw-px-4 tw-pb-24 tw-pt-8 sm:tw-px-6 lg:tw-px-8">
      <Reveal className="tw-mx-auto tw-max-w-6xl">
        {/* drop-shadow (not box-shadow) on the wrapper: it follows the
            punched alpha silhouette, so the shadow shows through the notch
            holes instead of leaving them as bright discs. A mask on the
            card itself would erase a shadow painted by the card. */}
        <div className="tw-rounded-3xl tw-drop-shadow-[0_30px_35px_rgba(0,77,64,0.45)]">
          <div className="tf-ticket-punch tw-relative tw-overflow-hidden tw-rounded-3xl tw-bg-gradient-to-br tw-from-[#00695C] tw-via-[#004D40] tw-to-[#00251F]">
            {/* Faint contour texture */}
            <svg
              aria-hidden="true"
              className="tw-pointer-events-none tw-absolute tw-inset-0 tw-h-full tw-w-full tw-text-white tw-opacity-[0.06]"
              preserveAspectRatio="xMidYMid slice"
              viewBox="0 0 1200 400"
            >
              <g fill="none" stroke="currentColor" strokeWidth="1.2">
                <path d="M-60 80c180-60 360 50 540-10s320-70 540-20 240 60 240 60" />
                <path d="M-60 140c180-60 360 50 540-10s320-70 540-20 240 60 240 60" />
                <path d="M-60 300c200-80 380 60 560 0s300-90 520-30 240 70 240 70" />
                <path d="M-60 360c200-80 380 60 560 0s300-90 520-30 240 70 240 70" />
              </g>
            </svg>

            <div className="tw-relative tw-grid tw-grid-cols-1 lg:tw-grid-cols-[1fr_270px]">
              {/* Main panel */}
              <div className="tw-p-9 sm:tw-p-14">
                <p className="tw-mb-6 tw-mt-0 tw-font-mono tw-text-[11px] tw-font-semibold tw-tracking-[0.3em] tw-text-primary-200">
                  BOARDING PASS · TF-001 · PASSENGER: YOU
                </p>
                <h2
                  className={`${fraunces.className} tw-m-0 tw-text-4xl tw-font-semibold tw-leading-[1.05] tw-tracking-tight tw-text-white sm:tw-text-6xl`}
                >
                  Ready for{' '}
                  <em className="tw-italic tw-text-primary-200">departure?</em>
                </h2>
                <p className="tw-mb-0 tw-mt-5 tw-max-w-lg tw-text-lg tw-leading-relaxed tw-text-primary-100/80">
                  Set up tonight, publish your first story this week. Your
                  future readers are already here.
                </p>
                <div className="tw-mt-9 tw-flex tw-flex-wrap tw-items-center tw-gap-5">
                  <CtaButton onClick={onJoin} light>
                    Start your travel blog
                    <ArrowIcon />
                  </CtaButton>
                  <span className="tw-font-mono tw-text-xs tw-tracking-wide tw-text-primary-200/80">
                    From $19/year · Cancel anytime
                  </span>
                </div>
              </div>

              {/* Tear-off stub */}
              <div className="tw-relative tw-hidden tw-flex-col tw-justify-between tw-p-9 lg:tw-flex">
                {/* Perforation */}
                <div
                  aria-hidden="true"
                  className="tw-absolute tw-bottom-6 tw-left-0 tw-top-6 tw-w-px tw-border-0 tw-border-l tw-border-dashed tw-border-white/30 [border-left-width:2px]"
                />
                <dl className="tw-m-0 tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-5 tw-font-mono">
                  <div>
                    <dt className="tw-text-[9px] tw-tracking-[0.25em] tw-text-primary-300">
                      FROM
                    </dt>
                    <dd className="tw-m-0 tw-mt-1 tw-text-sm tw-font-bold tw-text-white">
                      SOMEDAY
                    </dd>
                  </div>
                  <div>
                    <dt className="tw-text-[9px] tw-tracking-[0.25em] tw-text-primary-300">
                      TO
                    </dt>
                    <dd className="tw-m-0 tw-mt-1 tw-text-sm tw-font-bold tw-text-white">
                      PUBLISHED
                    </dd>
                  </div>
                  <div>
                    <dt className="tw-text-[9px] tw-tracking-[0.25em] tw-text-primary-300">
                      GATE
                    </dt>
                    <dd className="tw-m-0 tw-mt-1 tw-text-sm tw-font-bold tw-text-white">
                      A1
                    </dd>
                  </div>
                  <div>
                    <dt className="tw-text-[9px] tw-tracking-[0.25em] tw-text-primary-300">
                      SEAT
                    </dt>
                    <dd className="tw-m-0 tw-mt-1 tw-text-sm tw-font-bold tw-text-white">
                      1A
                    </dd>
                  </div>
                </dl>
                {/* Barcode */}
                <div
                  aria-hidden="true"
                  className="tw-mt-6 tw-h-12 tw-w-full tw-rounded-sm tw-opacity-80 [background:repeating-linear-gradient(90deg,#fff_0,#fff_2px,transparent_2px,transparent_5px,#fff_5px,#fff_6px,transparent_6px,transparent_11px)]"
                />
                <Stamp
                  className="tw-absolute tw-bottom-16 tw-right-5 tw-h-20 tw-w-20 tw-rotate-[-14deg] tw-text-amber-400/80"
                  text="APPROVED · BON VOYAGE · "
                />
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
